import { render, staticRenderFns } from "./show_text_lng.vue?vue&type=template&id=b7e70c90&scoped=true"
import script from "./show_text_lng.vue?vue&type=script&lang=js"
export * from "./show_text_lng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e70c90",
  null
  
)

export default component.exports